@if (selectedCi) {
	<div class="cmdb-register-page">
		<div class="header">
			<div class="title">{{ labels.lbl_geral_cadastro_ci }}</div>
		</div>

		<div class="navigation">
			<a [routerLink]="'/cmdb/list'">< {{ labels.lbl_asset_inventario }}</a>
		</div>

		@if (ciList.length > 1) {
			<div class="ci-list-container">
				@for (ciHeader of ciList; track ciHeader) {
					<div class="ci" [ngClass]="{ selected: ciHeader.id === selectedCi?.id }" (click)="changeCiInView(ciHeader)">
						{{ ciHeader.id }} - {{ ciHeader.identification }} - {{ ciHeader.type }}
					</div>
				}
			</div>
		}

		<div class="cmdb-register-container">
			<div class="folder-container" [ngStyle]="{ width: isImpactMapOpen ? '50%' : '100%' }">
				<div class="tab-container">
					<span class="tab" [ngClass]="{ selected: tabView === 'info' }" (click)="changeTab('info')">{{
						labels.lbl_geral_informacoes
					}}</span>
					@if (selectedCi.id !== '') {
						<span class="tab" [ngClass]="{ selected: tabView === 'bond' }" (click)="changeTab('bond')">
							{{ labels.lbl_geral_vinculos }}
						</span>
						<span class="tab" [ngClass]="{ selected: tabView === 'logs' }" (click)="changeTab('logs')"> LOG </span>
						<span class="tab" [ngClass]="{ selected: tabView === 'attachment' }" (click)="changeTab('attachment')">
							{{ labels.lbl_geral_anexo }}
						</span>
					}
					@if (selectedCi.id !== '' && cmdbDigitalTermLogPayload?.length > 0) {
						<span class="tab" [ngClass]="{ selected: tabView === 'digitalTerm' }" (click)="changeTab('digitalTerm')">
							{{ labels.lbl_termo_digital }}
						</span>
					}
					@if (selectedCi.id !== '' && PermissionService.hasPermission('access_myasset')) {
						<span class="tab" [ngClass]="{ selected: tabView === 'inconsistencies' }" (click)="changeTab('inconsistencies')">
							{{ labels.lbl_geral_inconsistencias }}
						</span>
					}
					@if (selectedCi.id !== '') {
						<div
							class="tab hide-on-small right"
							(click)="isImpactMapOpen = !isImpactMapOpen; isImpactMapOpen === true ? (formColumns = 1) : (formColumns = 2)">
							<span>{{ labels.lbl_geral_mapa_impacto }}</span>
							<span><fa-icon [icon]="isImpactMapOpen ? icons.faAngleLeft : icons.faAngleRight"></fa-icon></span>
						</div>
					}
				</div>

				<div class="tab-info-container" [ngStyle]="{ display: tabView === 'info' ? null : 'none' }">
					<cpi-cmdb-register-page-info
						[selectedCi]="selectedCi"
						[(viewType)]="viewType"
						[cameFromCmdbList]="cameFromCmdbList"
						[cmdbListQueryParams]="cmdbListQueryParams"
						[formColumns]="formColumns"
						[lockViewType]="lockViewType"
						[(baselineDate)]="baselineDate">
					</cpi-cmdb-register-page-info>
				</div>

				<div class="tab-bond-container" [ngStyle]="{ display: tabView === 'bond' ? null : 'none' }">
					<cpi-cmdb-register-page-bond [selectedCi]="selectedCi" [viewType]="viewType"></cpi-cmdb-register-page-bond>
				</div>

				<div class="tab-log-container" [ngStyle]="{ display: tabView === 'logs' ? null : 'none' }">
					<cpi-cmdb-register-page-logs
						[selectedCi]="selectedCi"
						(getLogDate)="baselineDate = $event; viewType = 'read'; tabView = 'info'">
					</cpi-cmdb-register-page-logs>
				</div>

				<div
					class="digital-term-container"
					[ngStyle]="{ display: tabView === 'digitalTerm' ? null : 'none' }"
					*ngIf="tabView === 'digitalTerm'">
					<ng-container *ngIf="!isLoadingLogTerm">
						<div class="digital-term" *ngIf="!cmdbDigitalTermLogPayload || cmdbDigitalTermLogPayload.length == 0">
							{{ labels.lbl_nao_existem_logs_termos_digitais }}
						</div>

						<ng-container *ngIf="cmdbDigitalTermLogPayload && cmdbDigitalTermLogPayload.length > 0">
							<div class="digital-term" *ngFor="let term of cmdbDigitalTermLogPayload; let index = index">
								<ng-container *ngIf="term.term_type !== 'ERROR'">
									<span class="digital-term-date">
										<span>{{ DateService.formatDate(term.generation_date) }}</span> -
										<span>{{
											term.term_type === 'RESPONSIBILITY'
												? labels['lbl_termo_responsabilidade']
												: term.term_type === 'DEVOLUTION'
													? labels['lbl_termo_devolucao']
													: term.term_type
										}}</span>
										<span *ngIf="term.signature"> ({{ labels.lbl_termo_assinado }})</span>
									</span>
									<span class="digital-term-date">{{ term.user }}</span>

									<span class="digital-term-notes">
										<b>{{ labels.lbl_checklist }}:</b>
										{{ term.checklist === '1' ? labels.lbl_geral_sim : labels.lbl_cmdb_nao }}<br />
										<b>{{ labels.lbl_gerar_e_enviar }}:</b>
										{{ term.generate_send === '1' ? labels.lbl_geral_sim : labels.lbl_cmdb_nao }}<br />
										<b>{{ labels.lbl_usuario_terceiro }}:</b>
										{{ term.third_party_user === '1' ? labels.lbl_geral_sim : labels.lbl_cmdb_nao }}<br />
										<b>{{ labels.lbl_usuario_desligado }}:</b>
										{{ term.user_disconnected === '1' ? labels.lbl_geral_sim : labels.lbl_cmdb_nao }}<br />
										<b>{{ labels.lbl_devolucao_troca_equipamento }}:</b>
										{{ term.return_or_exchange_equipment === '1' ? labels.lbl_geral_sim : labels.lbl_cmdb_nao }}<br />
										<b>{{ labels.lbl_tipo_de_termo }}:</b> {{ term.term_type }}<br />
										<b>{{ labels.lbl_geral_identificacao }}: </b> {{ term.identification || term.serial_number }}<br />
										<!-- <b>UUID:</b> {{ term.uuid }}<br> -->
										<b>{{ labels.lbl_assinatura_digital }}:</b> {{ term.signature || 'N/A' }}<br />
										<span *ngIf="term.analyst && term.analyst !== 'N/A'">
											<b>{{ labels.lbl_geral_solicitante }}:</b> {{ term.analyst }}<br />
										</span>
									</span>
									<div class="button-container link" *ngIf="term.signature && term.file">
										<span>{{ term.file }}</span>
										<span class="file-button" (click)="downloadDigitalTerm(term.file)"
											><fa-icon [icon]="icons.faDownload"></fa-icon
										></span>
									</div>
								</ng-container>

								<ng-container *ngIf="term.term_type === 'ERROR'">
									{{ labels.lbl_problema_carregar_log }}
								</ng-container>
							</div>
						</ng-container>
					</ng-container>

					<cpi-square-post-loading-effect *ngIf="isLoadingLogTerm"></cpi-square-post-loading-effect>
				</div>

				<div class="attachment-container" [ngStyle]="{ display: tabView === 'attachment' ? null : 'none' }">
					<pcp-cmdb-register-page-attachment [viewType]="viewType" [selectedCi]="selectedCi"> </pcp-cmdb-register-page-attachment>
				</div>

				<div class="inconsistencies-container" [ngStyle]="{ display: tabView === 'inconsistencies' ? null : 'none' }">
					<pcp-cmdb-register-page-inconsistencies [viewType]="viewType" [selectedCi]="selectedCi" [labels]="labels">
					</pcp-cmdb-register-page-inconsistencies>
				</div>
			</div>

			@if (isImpactMapOpen) {
				<div
					class="impact-map-container"
					[ngClass]="{ 'loading-relationship': isLoadingImpactMapCiParents || isLoadingImpactMapCiChildrens }"
					[ngStyle]=""
					(mousedown)="mouseDownImpactMap($event)"
					(mouseup)="mouseUpImpactMap()"
					(mousemove)="confirmMouseMoveImpactMap()"
					id="impactMapContainer">
					<p-organizationChart
						[ngClass]="{ 'mouse-down': impactMapPos.mouseDown && impactMapPos.mouseMove }"
						[ngStyle]="{
							transform:
								'matrix(' +
								impactMapPos.zoomLevel +
								', 0, 0,' +
								impactMapPos.zoomLevel +
								',' +
								impactMapPos.x +
								',' +
								impactMapPos.y +
								')',
						}"
						[(value)]="impactMapData"
						selectionMode="single"
						[selection]="selectedNode"
						(onNodeSelect)="onNodeSelect($event.node)"
						id="impactMapChart">
						<ng-template let-node pTemplate="default">
							<div class="impact-node-container" id="impactNodeContainer">
								<div class="header">
									@if (node.data.identification) {
										<span class="ci-name" *ngIf="" [title]="node.data.identification">
											{{ node.data.identification }}
										</span>
									}
									<span class="ci-status" [ngClass]="node.data.status"></span>
								</div>
								@if (impactMapView === 'cmdb') {
									<div>{{ labels.lbl_geral_status }}: {{ node.data.status }}</div>
								}
								@if (impactMapView === 'stock') {
									<div
										class="node-body-grid"
										[ngClass]="{ 'node-sp-2': node.data.stock.isConsumable !== true && !node.data.stock.responsible }">
										@if (node.data.stock.isConsumable === true) {
											<span>{{ labels.lbl_geral_quan_est }}:</span> <span>{{ node.data.stock.quantityStock }}</span>
											<span>{{ labels.lbl_status_em_uso }}:</span> <span>{{ node.data.stock.quantityUse }}</span>
										}

										@if (node.data.stock.isConsumable !== true) {
											@if (node.data.stock.responsible) {
												<span>{{ labels.lbl_usuario_responsavel }}:</span>
												<span>{{ node.data.stock.responsible }}</span>
												<span>{{ labels.lbl_data_prevista_devolucao }}:</span>
												<span>{{ node.data.stock.expectedReturnDate }}</span>
												<span>{{ labels.lbl_geral_data_retorno }}:</span>
												<span>{{ node.data.stock.returnDate }}</span>
											} @else {
												<span>{{ labels.lbl_sem_responsavel }}</span>
											}
										}
									</div>
								}
								<div class="node-extra-button-container">
									@if (node.data.isLeaf) {
										<div class="node-extra-button top" (click)="expandCiTreeDown($event, node)">
											<fa-icon [icon]="icons.faSortDown"></fa-icon>
										</div>
									}
									@if (node.data.isRoot) {
										<div class="node-extra-button bottom" (click)="expandCiTreeUp($event, node)">
											<fa-icon [icon]="icons.faSortUp"></fa-icon>
										</div>
									}
								</div>
							</div>
						</ng-template>
					</p-organizationChart>

					<div class="impact-map-button-container">
						<div class="ball" [ngClass]="{ disabled: impactMapPos.zoomLevel === 3 }" (click)="zoomInImpactMap()">
							<fa-icon [icon]="icons.faMagnifyingGlassPlus"></fa-icon>
						</div>
						<div class="ball" [ngClass]="{ disabled: impactMapPos.zoomLevel === 0.5 }" (click)="zoomOutImpactMap()">
							<fa-icon [icon]="icons.faMagnifyingGlassMinus"></fa-icon>
						</div>
						<div class="ball" (click)="impactMapPos.x = 0; impactMapPos.y = 0">
							<fa-icon [icon]="icons.faArrowsToDot"></fa-icon>
						</div>
					</div>

					@if (impactMapPos.mouseDown === true && impactMapPos.mouseMove === true) {
						<div
							class="impact-map-plastic-wrap"
							(mouseup)="mouseUpImpactMap()"
							(mouseout)="mouseUpImpactMap()"
							(mousemove)="moveImpactMap($event)"></div>
					}
				</div>
			}
		</div>
	</div>
} @else {
	<div class="loading-container">
		<cpi-svg-gears></cpi-svg-gears>
		<div>{{ labels.lbl_edocs_carregando }}!</div>
	</div>
}
